import { AulaEditor } from '@ublend-npm/aula-editor';
import withPlugins from './withPlugins';
import withFileBlocksValidation from './withFileBlocksValidation';
import withAnalytics from './withAnalytics';
import withCustomStyles from './withCustomStyles';
import withErrorBoundary from '../ErrorBoundary/ErrorBoundary';
import withFileScanFromRedux from './withFileScanFromRedux';

const AulaEditorWithAnalytics = withErrorBoundary(
  withCustomStyles(
    withFileScanFromRedux(
      withAnalytics(withFileBlocksValidation(withPlugins(AulaEditor)))
    )
  ),
  { ignore: true }
);

export default AulaEditorWithAnalytics;
